var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "#EFF0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 28.0035L27.6422 32.8246C27.7734 32.8902 27.839 32.923 27.9078 32.9359C27.9687 32.9473 28.0313 32.9473 28.0922 32.9359C28.161 32.923 28.2266 32.8902 28.3578 32.8246L38 28.0035M18 33.0035L27.6422 37.8246C27.7734 37.8902 27.839 37.923 27.9078 37.9359C27.9687 37.9473 28.0313 37.9473 28.0922 37.9359C28.161 37.923 28.2266 37.8902 28.3578 37.8246L38 33.0035M18 23.0035L27.6422 18.1824C27.7734 18.1168 27.839 18.084 27.9078 18.0711C27.9687 18.0596 28.0313 18.0596 28.0922 18.0711C28.161 18.084 28.2266 18.1168 28.3578 18.1824L38 23.0035L28.3578 27.8246C28.2266 27.8902 28.161 27.923 28.0922 27.9359C28.0313 27.9473 27.9687 27.9473 27.9078 27.9359C27.839 27.923 27.7734 27.8902 27.6422 27.8246L18 23.0035Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTask);
export default __webpack_public_path__ + "static/media/viewTask.4f386cc9b4b5919ae6d06103a9e9e9a4.svg";
export { ForwardRef as ReactComponent };